import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { TheoryPractice } from './components/TheoryPractice';
import { Volumes } from './components/Volumes';
import { FitCheck } from './components/FitCheck';
import { Bonuses } from './components/Bonuses';
import { StickyBuyBar } from './components/StickyBuyBar';
import { Offer } from './components/Offer';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { FormatNotice } from './components/FormatNotice';
import { Faqs } from './components/Faqs';
import { Contact } from './components/Contact';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
import { InlineCta } from './components/InlineCta';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Arsenał Nauczyciela Jazzu™ — 6 tomów + 6 bonusów dla nauczycieli gitary jazzowej';
    initMetaPixel();
  }, []);
  return <div lang="pl" className="w-full bg-night pb-[68px] font-sans text-cream sm:pb-0" data-id="element-0" data-mp="2zld43f9knpe6">
      <noscript data-id="element-1" data-mp="33morde4z3yj7">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="33m5bs42spm8c" />
      </noscript>
      <PromoBar data-id="element-3" data-mp="3dlnu6g324zya" />
      <Hero data-id="element-4" data-mp="3dm5z013scmht" />
      <SocialProofBar data-id="element-5" data-mp="3dirvuqnas99b" />
      <Problems data-id="element-6" data-mp="nvsvh92bsvy2" />
      <InlineCta tone="wine-dark" label="Chcę skończyć z improwizacją" data-id="element-7" data-mp="nwc2huqftzxb" />
      <SystemOverview data-id="element-8" data-mp="sunas11342df" />
      <TheoryPractice data-id="element-9" data-mp="su427axbqqc2" />
      <InlineCta tone="night-900" label="Chcę teorię + 50 ćwiczeń" data-id="element-10" data-mp="stc7e2bjwwmu" />
      <Volumes data-id="element-11" data-mp="35yomiyqxk0x" />
      <InlineCta tone="night-900" label="Chcę wszystkie 6 tomów" data-id="element-12" data-mp="35glr3hkw7k1" />
      <FitCheck data-id="element-13" data-mp="3ud1hdeu8fyd9" />
      <Bonuses data-id="element-14" data-mp="3udazyhcy738x" />
      <InlineCta tone="night-900" label="Chcę pakiet z 6 bonusami" data-id="element-15" data-mp="3ubri4mbn8k51" />
      <Offer data-id="element-16" data-mp="d4e5lt427cwp" />
      <HowItWorks data-id="element-17" data-mp="d4xopd5g47cb" />
      <Guarantee data-id="element-18" data-mp="d3cvprys4wgk" />
      <FormatNotice data-id="element-19" data-mp="d3wbp34vdary" />
      <Faqs data-id="element-20" data-mp="d2bhxfqdpvv5" />
      <InlineCta tone="night" label="Tak, kupuję Arsenał" data-id="element-21" data-mp="85uj9rljzz3t" />
      <Comparison data-id="element-22" data-mp="86cmj86mvdl8" />
      <InlineCta tone="night-900" label="Zacznij uczyć z systemem" data-id="element-23" data-mp="83qihiiybg7r" />
      <FinalCall data-id="element-24" data-mp="3glwbhv09u9uh" />
      <ClosingWords data-id="element-25" data-mp="3gja7u6gi4ehj" />
      <InlineCta tone="night" label="Zdobądź Arsenał teraz" data-id="element-26" data-mp="3bmbgfvo82ln1" />
      <Contact data-id="element-27" data-mp="3bo4mb8r0h1tz" />
      <SiteFooter data-id="element-28" data-mp="3bk72sm0iu89k" />
      <StickyBuyBar data-id="element-29" data-mp="3qb7lrkyw9kjy" />
    </div>;
}